import axios from 'axios'
import API from '@/common/api'
import store from '..'
import router from '@/router'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getWaitingcallData ({ dispatch, state }) {
      const file = 'waitingcall/waitingcall.json'
      return axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=${file}`).then(res => {
        return res.data.message
      }).catch((ex) => {
        return false
      })
    },
    async getSpaceCodeSetting ({ state }, spaceCode) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-waiting-call',
          func: 'get-waiting-call-spaceCode',
          siteid: siteInfo.site,
          spaceCode: spaceCode
        })
        return res.response && res.response.data
          ? res.response.data
          : res.data && res.data.errorMessage ? JSON.parse(res.data.errorMessage) : res
      } catch (ex) {
        console.log(ex)
        return ex
      }
    },
    // 사용자 인증정보 전달
    async authWaiting ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-waiting-call',
          func: 'auth-waiting',
          siteid: siteInfo.site,
          spaceCode: data.spaceCode,
          auth: {
            type: data.authType,
            data: data.authData
          }
        })
        return res.response && res.response.data
          ? res.response.data
          : res.data && res.data.errorMessage ? JSON.parse(res.data.errorMessage) : res
      } catch (ex) {
        console.log(ex)
        return ex
      }
    },
    async requestWaiting ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-waiting-call',
          func: 'request-wait',
          siteid: siteInfo.site,
          spaceCode: data.spaceCode,
          sendMethod: data.sendMethod,
          userLanguage: data.userLanguage,
          rid: data.rid,
          ...data.name && {
            name: data.name
          },
          customFields: data.customFields,
          customFieldsData: data.customFieldsData
        })
        return res.response && res.response.data
          ? res.response.data
          : res.data && res.data.errorMessage ? JSON.parse(res.data.errorMessage) : res
      } catch (ex) {
        console.log(ex)
        return ex
      }
    },
    async getWaitingcallStatus ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-waiting-call',
          func: 'get-waiting-call-status',
          siteid: siteInfo.site,
          spaceCode: data.spaceCode,
          rid: data.rid
        })
        return res.response && res.response.data
          ? res.response.data
          : res.data && res.data.errorMessage ? JSON.parse(res.data.errorMessage) : res
      } catch (ex) {
        console.log(ex)
        return ex
      }
    }
  },
  getters: {
    getWaitingcallResultData: () => (code) => {
      let result = true
      switch (code) {
        case 201:
          result = 'duplicate' // 중복등록(중복인증X)
          break
        case 210:
          result = 'group' // 그룹예약이 등록시도 할 경우
          break
        case 211:
          result = 'invalid_checkin' // 체크인 당일이 아닌 경우
          break
        case 220:
          result = 'fail_send' // 메시지 전송 실패
          break
        case 300:
          result = 'fail_auth' // 예약 정보가 없거나 인증 실패
          break
        case 306:
          result = 'not_available_time' // 예약 정보가 없거나 인증 실패
          break
        case 401:
          result = 'inactivate' // 비활성화 또는 서비스 하지 않는 사이트
          break
        case 403:
          result = 'invalid_request' // 유효하지 않은 요청 데이터
          break
        case 405:
          result = 'invalid_site' // 사이트 정보가 없음
          break
        case 406:
          result = 'not_found_data' // 데이터가 없음
          break
        case 500:
          result = 'system_error' // 내부 오류
          break
      }
      return result
    }
  }
}
